import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import SpecteraFormButton from '../SpecteraFormButton'
import SpecteraContactBenefit from './SpecteraContactBenefit'
import SpecteraFramesBenefit from './SpecteraFramesBenefit'
import SpecteraLensBenefit from './SpecteraLensBenefit'
import { specteraStyleListLoad } from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/spectera/specteraAction'
import { visionInsuranceClaimFormEdit } from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'

function SpecteraFinalStep(props) {
  const { visionInsuranceClaimForm, portalType, specteraAddOn } = props
  const dispatch = useDispatch()
  const { data: eligibilityData = [] } = visionInsuranceClaimForm?.eligibility ?? {}
  const showContactBenefit = Boolean(eligibilityData.find(item => item.service_type === 'Contacts Benefit')?.active)
  const showFrameBenefit = Boolean(eligibilityData.find(item => item.service_type === 'Frame Benefit')?.active)
  const showLensBenefit = Boolean(eligibilityData.find(item => item.service_type === 'Lens Benefit')?.active)
  const hasMaterialsBenefit = showContactBenefit || showFrameBenefit || showLensBenefit

  const [styleListLoading, setStyleListLoading] = useState(showContactBenefit)

  const selectedLocation = specteraAddOn?.config?.locations?.find(
    loc => loc.name === specteraAddOn?.config?.creds?.location
  ) || {}

  useEffect(() => {
    if (!hasMaterialsBenefit) {
      dispatch(visionInsuranceClaimFormEdit({ activeModule: '', formView: 'overview' }))
    }
  }, [hasMaterialsBenefit, dispatch])

  useEffect(() => {
    if (!showContactBenefit) return

    const loadStyleList = async () => {
      setStyleListLoading(true)
      try {
        await Promise.all([
          Promise.resolve(dispatch(specteraStyleListLoad(visionInsuranceClaimForm.id, {
            lens_type: 'os',
            location_id: selectedLocation.id,
            vision_benefit_id: 1,
          }))),
          Promise.resolve(dispatch(specteraStyleListLoad(visionInsuranceClaimForm.id, {
            lens_type: 'od',
            location_id: selectedLocation.id,
            vision_benefit_id: 1,
          }))),
        ])
      } finally {
        setStyleListLoading(false)
      }
    }

    loadStyleList()
  }, [showContactBenefit, visionInsuranceClaimForm.id, selectedLocation.id])

  if (!hasMaterialsBenefit) {
    return null
  }

  if (styleListLoading) {
    return (
      <div className='bg-white p-6 border rounded d-flex flex-column align-items-center justify-content-center' style={{ minHeight: '20rem' }}>
        <div className="spinner-border text-primary mb-4" role="status" aria-hidden="true" />
        <span className="text-muted">Loading contact lens styles...</span>
      </div>
    )
  }

  return (
    <div className='bg-white p-6 border rounded'>
      {showFrameBenefit && <SpecteraFramesBenefit portalType={portalType} />}
      {showFrameBenefit && (showLensBenefit || showContactBenefit) && <hr />}
      {showLensBenefit && <SpecteraLensBenefit portalType={portalType} visionInsuranceClaimForm={visionInsuranceClaimForm} />}
      {showLensBenefit && showContactBenefit && <hr />}
      {showContactBenefit && <SpecteraContactBenefit portalType={portalType} visionInsuranceClaimForm={visionInsuranceClaimForm} location_id={selectedLocation.id} />}
      <SpecteraFormButton backStep='second' />
    </div>
  )
}

const mapStateToProps = (state) => {
  const { visionInsurance } = state
  return {
    specteraAddOn: visionInsurance?.services?.find(item => item.config.service === "spectera") || {},
  }
}

export default connect(mapStateToProps)(SpecteraFinalStep)
